/* ══ THE NAV FIT GUARD ═══════════════════════════════════════════════════════
   CLIENT, AS A STANDING RULE: "i dont ever want any menu items hidden."

   THE INVARIANT. This nav has exactly two legal states and no third:
     · every link visible in the top row, or
     · the trigger showing, with every link in the drawer.
   A partial row is a bug, always. The rule that used to hide links 5+ below
   1100px is deleted from the stylesheet; this file is what keeps the promise
   once the pixel boundary alone is no longer enough.

   WHY IT EXISTS AT ALL. The 1000px handover in bm-channel.css is measured
   against the SEVEN items main-menu has today. The menu is admin-driven now,
   so somebody will add an eighth in the Shopify admin and nobody will re-open
   this file to re-measure. Without a guard the eighth link would push the
   whole row wider until the CART is shoved past the right edge -- and .bmvh
   carries overflow-x:hidden, so it would not even leave a scrollbar behind.
   Silent loss of the cart is the failure the old truncation rule was quietly
   preventing, and it is strictly worse than showing a trigger.

   BINARY BY CONSTRUCTION. The only thing this script can do is add or remove
   ONE class on the section root, and that class swaps the whole row for the
   trigger. There is no code path here that can hide an individual link, which
   is the property that makes the invariant hold rather than merely holding
   today.
   ═════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  if (window.__BMVH_NAV_BOOTED) return;
  window.__BMVH_NAV_BOOTED = true;

  var root = document.querySelector(".bmvh");
  if (!root) return;
  var nav   = root.querySelector(".hero-nav");
  var links = root.querySelector(".navlinks");
  var mark  = root.querySelector(".wordmark");
  var cart  = root.querySelector("#cart-icon-bubble");
  if (!nav || !links || !mark || !cart) return;

  /* The row must clear the wordmark by at least this much to read as a gap
     rather than a collision. It is the inter-link gap at the handover width,
     so "as far from the wordmark as the links are from each other". */
  var CLEAR = 20;
  /* And the cart must stay this far inside the right edge. Small on purpose:
     the point is to catch the cart LEAVING the viewport, not to police
     aesthetics the stylesheet already handles. */
  var EDGE = 6;

  /* The stylesheet already shows the trigger below this, so there is nothing
     for the guard to decide down there. Kept identical to the CSS boundary --
     if you change one, change the other. */
  var wideQ = window.matchMedia("(min-width:1000px)");

  function fits() {
    var l = links.getBoundingClientRect();
    var w = mark.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    if (l.width === 0) return false;           /* not laid out -> do not claim it fits */
    if (l.left - w.right < CLEAR) return false;
    if (c.right > vw - EDGE) return false;
    if (l.right > vw) return false;
    return true;
  }

  /* MEASURED IN THE EXPANDED STATE, SYNCHRONOUSLY. Once collapsed the links
     are display:none and cannot be measured, so the class comes off, the
     layout is read back (that read forces the reflow), and the class goes on
     again if it is still needed -- all inside one task. The browser does not
     paint mid-task, so nothing flickers even when the answer does not change. */
  function evaluate() {
    if (!wideQ.matches) { root.classList.remove("nav-collapsed"); return; }
    root.classList.remove("nav-collapsed");
    if (!fits()) root.classList.add("nav-collapsed");
  }

  /* rAF-coalesced: a drag-resize fires continuously and each pass costs a
     forced reflow, so collapse the storm into one measurement per frame. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; evaluate(); });
  }

  evaluate();

  /* The brand face is a webfont. Metrics change the moment it lands, and a
     fallback renders wider than the real thing -- exactly the case the 75px
     of slack in the CSS boundary is there to absorb. Re-measure when the
     fonts settle, and once more after, for a face that arrives late. */
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(schedule).catch(function () {});
  }
  setTimeout(schedule, 1200);

  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("orientationchange", schedule, { passive: true });
  if (wideQ.addEventListener) wideQ.addEventListener("change", schedule);
  else if (wideQ.addListener) wideQ.addListener(schedule);

  /* Catches anything that changes the row without changing the window: a late
     cart-count bubble widening the cart, or links being written in by an app. */
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(nav);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(links, { childList: true, subtree: true });
  }
})();
